import { useEffect, useRef } from "react";

export default function SparksCanvas({ className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let raf, w, h;

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * DPR;
      canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const embers = [];
    const spawnEmber = (init) => ({
      x: Math.random() * w,
      y: init ? Math.random() * h : h + 10,
      vx: (Math.random() - 0.5) * 0.3,
      vy: -(0.35 + Math.random() * 0.9),
      r: 0.6 + Math.random() * 1.6,
      t: Math.random() * Math.PI * 2,
    });
    for (let i = 0; i < 55; i++) embers.push(spawnEmber(true));

    const sparks = [];
    const onMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      for (let i = 0; i < 3; i++) {
        const a = Math.random() * Math.PI * 2;
        const s = 0.6 + Math.random() * 1.8;
        sparks.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 0.6, r: 0.8 + Math.random() * 1.4, life: 1 });
      }
      if (sparks.length > 220) sparks.splice(0, sparks.length - 220);
    };
    const host = canvas.parentElement;
    host.addEventListener("pointermove", onMove);

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const e of embers) {
        e.t += 0.03;
        e.x += e.vx + Math.sin(e.t) * 0.15;
        e.y += e.vy;
        if (e.y < -10 || e.x < -10 || e.x > w + 10) Object.assign(e, spawnEmber(false));
        const a = 0.22 + 0.35 * (0.5 + 0.5 * Math.sin(e.t * 2));
        ctx.fillStyle = `rgba(245, 158, 11, ${a})`;
        ctx.beginPath();
        ctx.arc(e.x, e.y, e.r, 0, 7);
        ctx.fill();
      }
      for (let i = sparks.length - 1; i >= 0; i--) {
        const s = sparks[i];
        s.x += s.vx;
        s.y += s.vy;
        s.vy += 0.04;
        s.life -= 0.02;
        if (s.life <= 0) {
          sparks.splice(i, 1);
          continue;
        }
        ctx.fillStyle = `rgba(255, ${180 + Math.floor(60 * s.life)}, 110, ${s.life * 0.9})`;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r * s.life, 0, 7);
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      host.removeEventListener("pointermove", onMove);
    };
  }, []);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
}
